var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18182 3.81818H11.1818L8.18182 0.818182V3.81818ZM3.27273 0H8.72727L12 3.27273V8.72727C12 9.0166 11.8851 9.29408 11.6805 9.49866C11.4759 9.70325 11.1984 9.81818 10.9091 9.81818H3.27273C2.66727 9.81818 2.18182 9.32727 2.18182 8.72727V1.09091C2.18182 0.801582 2.29675 0.524105 2.50134 0.31952C2.70592 0.114935 2.9834 0 3.27273 0ZM1.09091 2.18182V10.9091H10.9091V12H1.09091C0.801582 12 0.524105 11.8851 0.31952 11.6805C0.114935 11.4759 0 11.1984 0 10.9091V2.18182H1.09091Z",
    fill: "#CBCCE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmissions);
export default __webpack_public_path__ + "static/media/submissions.e624aa9e696c3b3fb22006a064256101.svg";
export { ForwardRef as ReactComponent };